var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.inPerilOfLosingBackerPlan
    ? _c("div", [
        _c(
          "div",
          { staticClass: "message with-icon danger" },
          [
            _c("font-awesome-icon", {
              staticClass: "decorative",
              attrs: { icon: _vm.$v6.solid.faBomb },
            }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "If your Pro Backer plan expires, you'll lose your special Backer subscription price!"
              ),
            ]),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }